import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../design-system/cn';
import Card from '../components/ui/Card';
import StadiumShell from './StadiumShell';
import { LockedInMarkIcon } from '../assets/brand/BrandIcons';
import { consoleShadows } from '../design-system/tokens';

/**
 * Shared shell for auth + onboarding pages — console aesthetic + stadium ghosts.
 * Presentation only — children carry all business logic.
 */
export default function AuthLayout({
  backHref = '/',
  backLabel = '← Back',
  showBack = true,
  maxWidth = 'md',
  children,
  className,
}) {
  const maxW = maxWidth === 'lg' ? 'max-w-lg' : 'max-w-md';

  return (
    <StadiumShell className="flex flex-col">
      <nav className="flex items-center justify-between px-6 py-6 max-w-7xl mx-auto w-full">
        <Link
          to="/"
          className="flex items-center gap-3 text-white hover:text-[#8cff4a] transition-colors"
        >
          <span className="h-10 w-10 rounded-xl border border-[#8cff4a]/30 bg-[#8cff4a]/10 flex items-center justify-center">
            <LockedInMarkIcon className="w-6 h-6 text-[#8cff4a]" />
          </span>
          <span className="text-xl font-black tracking-tighter uppercase italic">Locked In</span>
        </Link>
        {showBack && (
          <Link
            to={backHref}
            className="text-sm font-bold uppercase tracking-widest text-gray-400 hover:text-white transition-colors"
          >
            {backLabel}
          </Link>
        )}
      </nav>

      <main className={cn('flex-1 flex items-center justify-center px-6 py-12', className)}>
        <Card
          variant="premiumGlass"
          padding="lg"
          rounded="3xl"
          className={cn(
            'w-full relative overflow-hidden',
            maxW,
            'border border-white/10 ring-1 ring-[#8cff4a]/10',
            consoleShadows.card,
          )}
        >
          <div
            className="pointer-events-none absolute -right-8 -bottom-10 h-40 w-40 opacity-20"
            aria-hidden
          >
            <LockedInMarkIcon className="w-full h-full text-[#8cff4a]" />
          </div>
          <div className="relative z-10">{children}</div>
        </Card>
      </main>
    </StadiumShell>
  );
}
